import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=650e41f5"
import script from "./Carousel.vue?vue&type=script&lang=js"
export * from "./Carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('650e41f5')) {
      api.createRecord('650e41f5', component.options)
    } else {
      api.reload('650e41f5', component.options)
    }
    module.hot.accept("./Carousel.vue?vue&type=template&id=650e41f5", function () {
      api.rerender('650e41f5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/auth2/Carousel.vue"
export default component.exports